(function($, window, document) {
  window.HeaderFunctions = {
    setupSlider: function() {
      var sliderWrapper = $('#headerSlider');
      var slides        = sliderWrapper.find('.f-banner--lawyer--item');
      var wall          = sliderWrapper.find('.f-banner--lawyer--wall');
      var speed         = sliderWrapper.data('speed');

      var autoPlay = function() {
        var current = sliderWrapper.find('.f-banner--lawyer--item.active');
        var hasNext = (current.index()) < slides.length;

        current.removeClass('active')
        var next = hasNext ?  current.next() : slides.first();

        var wallColor = next.data('wallcolor');
        wall.css('backgroundColor', wallColor);

        next.addClass('active')
      }

      setInterval(function() {autoPlay()}, speed);
    }
  }
}(window.jQuery, window, document)); // End of jQuery wrapper
